import {ready} from '../main/utils';
import loadOnlineDistributors from './online-distributors';
import loadWhereToBuy from './where-to-buy';

ready(() => {
  loadOnlineDistributors();
  loadWhereToBuy();
});
